<template>
  <section>
    <div class="section-base__title-box">
      <div class="section-base__title">{{ RouteText.STATEMENTS_JOINT }}</div>
    </div>
    <div>
      <StatementsJointTable :pagination-show="true" />
    </div>
  </section>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';
import { RouteText } from '@/router';
import StatementsJointTable from '@/components/elements/statement/StatementsJointTable';

@Component({
  components: {
    StatementsJointTable,
  },
  data: () => ({
    RouteText,
  }),
})
export default class StatementsJoint extends Vue {}
</script>

<style scoped lang="scss"></style>
